module.exports = __webpack_public_path__ + "img/7.94d9f7be.jpg";